import { useState, useEffect } from 'react';
import { CustomerStatus } from '../features/customers/domain/types';

interface ResourceCheckResult {
    hasResourcesForRun: boolean;
    resourceLimitMessage: string | null;
}

export function useResourceCheck(customerStatus: CustomerStatus | null): ResourceCheckResult {
    const [hasResourcesForRun, setHasResourcesForRun] = useState(true);
    const [resourceLimitMessage, setResourceLimitMessage] = useState<string | null>(null);

    useEffect(() => {
        if (!customerStatus) return;

        // Check if customer has runs or MW capacity left
        const hasRunsLeft = customerStatus.gating_disabled || customerStatus.runs_remaining > 0;
        const hasMwLeft = customerStatus.gating_disabled || customerStatus.mw_remaining > 0;

        const canRunModel = hasRunsLeft && hasMwLeft;
        setHasResourcesForRun(canRunModel);

        // Set appropriate message if resources are depleted
        if (!hasRunsLeft) {
            setResourceLimitMessage("No model runs remaining this month");
        } else if (!hasMwLeft) {
            setResourceLimitMessage("No MW capacity remaining this month");
        } else {
            setResourceLimitMessage(null);
        }
    }, [customerStatus]);

    return { hasResourcesForRun, resourceLimitMessage };
}